import React, { useState } from 'react';
import { TextInput, StyleSheet, View } from 'react-native';

import Text from './Text';
import Image from './Image';

import {
  FONT_FAMILY,
  BASE_COLOR,
  FORM_WIDTH,
  FONT_FAMILY_BOLD,
  BUTTON_HEIGHT,
  GOLDEN200,
  pOrT,
} from '../styleConstants';

const styles = StyleSheet.create({
  base: {
    fontFamily: FONT_FAMILY,
    height: 18,
    padding: 0,
    width: 150,
    fontSize: 12,
    color: BASE_COLOR,
  },
  bold: {
    fontFamily: FONT_FAMILY_BOLD,
  },
  container: {
    height: 55,
    width: FORM_WIDTH,
  },
  label: {
    color: 'rgba(236, 203, 180, 0.6)',
    fontSize: pOrT(9, 11),
    marginTop: 5,
    marginLeft: 10,
    zIndex: 9,
  },
  middleLabel: {
    marginTop: -10,
    alignSelf: 'center',
  },
  input: {
    fontSize: pOrT(12, 14),
    height: 30,
    width: FORM_WIDTH - 20,
    zIndex: 9,
    color: GOLDEN200,
    marginLeft: 10,
    paddingTop: 2,
  },
  middleWrapper: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  middleItem: {
    marginTop: -10,
  },
});

type Props = {
  style?: any;
  inputRef?: any;
  [key: string]: any;
};

const TextInputWrapper = ({ style, inputRef, ...props }: Props) => (
  <TextInput
    underlineColorAndroid="transparent"
    disableFullscreenUI
    style={[styles.base, styles.bold, style]}
    ref={inputRef}
    {...props}
  />
);

export default TextInputWrapper;

type TextInputLabelProps = {
  label?: string;
  style?: any;
  inputStyle?: any;
  hint?: string;
  multiline?: boolean;
  width?: number;
  long?: boolean;
  [key: string]: any;
};

export const TextInputLabel = ({
  style,
  inputStyle,
  label,
  hint,
  multiline,
  long,
  width,
  ...props
}: TextInputLabelProps) => {
  const [focused, setFocused] = useState(false);

  return (
    <View style={[styles.container, style, multiline && { height: 76 }, width && { width }]}>
      {label ? (
        <Text bold style={styles.label}>
          {label}
          {hint ? ` (${hint})` : ''}
        </Text>
      ) : null}
      {!multiline ? (
        <Image
          style={{
            width: width || FORM_WIDTH,
            height: label ? 55 : BUTTON_HEIGHT,
            position: 'absolute',
          }}
          resizeMode="stretch"
          source={
            long
              ? !focused
                ? require('../../assets/images/inputBarLong.png')
                : require('../../assets/images/inputBarLongOn.png')
              : !focused
              ? require('../../assets/images/inputBar.png')
              : require('../../assets/images/inputBarOn.png')
          }
        />
      ) : (
        <Image
          style={{ width: FORM_WIDTH, height: 76, position: 'absolute' }}
          source={require('../../assets/images/inputBarMultiline.png')}
        />
      )}
      <TextInputWrapper
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={[
          styles.input,
          !label && { paddingTop: 8 },
          multiline && { height: 50 },
          inputStyle,
          width && { width: width - 20 },
        ]}
        multiline={multiline}
        {...props}
      />
    </View>
  );
};
